import axios from 'axios';
import Swal from 'sweetalert2';
import router from "@/router";
import { useAuthStore } from '@/stores/auth'

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // auth.js 的 watch({ immediate: true }) 已同步設定 axios.defaults.headers.common['Authorization']
  // 此處直接沿用，無需再次讀取 store
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Api回應統一異常處理
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 204) {
      // 各 view 自行處理成功/警告提示，攔截器不重複彈窗
      return response.data;
    }
  }, (error) => {
    if (error.response && error.response.data) {
      if (error.response.status === 401) {
        try{
          const auth = useAuthStore();
          auth.clearToken();
        } catch(e){
          console.warn('Failed to clear token from Pinia store in response interceptor', e);
        }
        // 清除 token 後導向登入頁，並帶回原始路徑以便登入後跳轉
        router.push({ name: 'Login', query: { redirect: router.currentRoute.value.fullPath } });
      }
      else if (error.response.status === 400) {
        console.log(error.response);
      }
      else {
        if (error.response.data.message) {
          Swal.fire({
            icon: 'error',
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 8500
          });
        }
      }
    } else {
      console.error("Unknown error occurred:", error.message || error);
      Swal.fire({
        icon: 'error',
        title: 'An unknown error occurred',
        text: error.message || 'No additional details available',
        showConfirmButton: true
      });
    }
    return Promise.reject(error.message || error);
  }
);

// get请求
export function apiGet(url, data = {}) {
  return axios.get(url, data);
}

// post请求
export function apiPostForm(url, data = {}) {
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

// post请求 (JSON)
export function apiPost(url, data = {}) {
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

// 請求上傳檔案
export function filepost(url, data = {}) {
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
